import LanguageDialog from "./LanguageDialog";
class LanguageSwitcher {
    static initEvents() {
        (document.querySelectorAll(".language-switcher .language-current")).forEach((el) => {
            el.addEventListener("click", LanguageSwitcher.toggleMenu);
        });
        (document.querySelectorAll(".language-switcher a")).forEach((el) => {
            el.addEventListener("click", () => {
                // If the user clicks on a language link, we can assume they want to change language
                LanguageDialog.setDismissedCookie();
            });
        });
    }
    static toggleMenu(event) {
        var _a;
        event.preventDefault();
        const current = event.currentTarget;
        const switcher = (_a = current === null || current === void 0 ? void 0 : current.closest(".language-switcher")) !== null && _a !== void 0 ? _a : null;
        if (switcher === null) {
            return;
        }
        switcher.classList.toggle("open");
    }
}
LanguageSwitcher.initEvents();
